/* app/js/src/components/graphics/edit/fields/scale.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.field-container {
  display: flex;
}
.label {
  flex: 1;
  align-self: center;
}
icn-number-input {
  width: 122px;
}
/*# sourceMappingURL=scale.component.css.map */
